import { ICellProps } from "@components/table/cells/Cells.types";
import {
    HeaderCellInner,
    IconWrapper,
    LabelGroup,
    SortDownIconStyled,
    SortIconStyled,
    StyledHeaderCell,
    ValueWrapper
} from "@components/table/Rows.styles";
import { HeaderTooltipIcon } from "@components/table/Table.styles";
import { ISort } from "@components/table/Table.types";
import React, { AriaAttributes, PureComponent } from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { Sort } from "../../../enums";
import TestIds from "../../../testIds";

interface IHeaderCellProps extends ICellProps {
    sort?: Sort;
    // if this column isn't sorted, next sort direction on click is selected
    // based on the current sort (on another column which actually has sort)
    currentSort?: Sort;
    info?: string;
    disableSort?: boolean;
    onClick?: (props: ISort) => void;
}

class HeaderCell extends PureComponent<IHeaderCellProps & WithTranslation> {
    onLabelGroupClick = (): void => {
        let sort: Sort;

        if (this.props.sort || !this.props.currentSort) {
            sort = !this.props.sort || this.props.sort === Sort.Desc ? Sort.Asc : Sort.Desc;
        } else {
            sort = this.props.currentSort;
        }

        if (this.props.onClick && !this.props.disableSort) {
            this.props.onClick({
                id: this.props.id,
                sort
            });
        }
    };

    getAriaSort = (): AriaAttributes["aria-sort"] => {
        if (!this.props.sort) {
            return null;
        }
        return this.props.sort === Sort.Asc ? "ascending" : "descending";
    };

    render() {
        // html2canvas doesn't support css rotation = >use two icons instead
        const currentSort = this.props.sort ?? this.props.currentSort;
        const Icon = !currentSort || currentSort === Sort.Asc ? SortIconStyled : SortDownIconStyled;

        return (
                <StyledHeaderCell
                        $isColumnHighlighted={this.props.isColumnHighlighted}
                        $isRowHighlighted={this.props.isRowHighlighted}
                        $border={this.props.border}
                        $isForPrint={this.props.isForPrint}
                >
                    {/*we don't wont to propagate all the props, for example onClick to header cell*/}
                    <HeaderCellInner $width={this.props.width}
                                     $first={this.props.first}
                                     $last={this.props.last}
                                     $hasAction={this.props.last && this.props.hasAction}
                                     $sticky={this.props.sticky}
                                     $textAlign={this.props.textAlign}
                                     aria-sort={this.getAriaSort()}
                                     data-testid={TestIds.TableHeaderCell}
                                     role="columnheader">
                        <LabelGroup $textAlign={this.props.textAlign}
                                    onClick={this.onLabelGroupClick}
                                    $disableSort={this.props.disableSort}>
                            <ValueWrapper $textAlign={this.props.textAlign}
                                          data-column-index={this.props.columnIndex}
                                          data-testid={TestIds.TableHeaderCellContent}>
                                {this.props.children}
                            </ValueWrapper>
                            {/* !!! IconWrapper has to be right next to ValueHelper because of hover styles */}
                            {
                                <IconWrapper $textAlign={this.props.textAlign}
                                             title={this.props.t(`Components:Table.${this.props.sort === Sort.Asc ? "Ascending" : "Descending"}`)}
                                             data-testid={this.props.sort ? TestIds.ColumnSortIconWrapper : null}>
                                    <Icon $sort={this.props.sort} $disableSort={this.props.disableSort}/>
                                </IconWrapper>
                            }
                            {this.props.info &&
                                    <HeaderTooltipIcon offsetY={18}>
                                        {this.props.info}
                                    </HeaderTooltipIcon>
                            }
                        </LabelGroup>
                    </HeaderCellInner>
                </StyledHeaderCell>
        );
    }
}

export const HeaderCellExtended = withTranslation(["Components"])(HeaderCell);
export { HeaderCellExtended as HeaderCell };